import React, { useState } from 'react';
import InventoryIcon from '@mui/icons-material/Inventory';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { Modal, Box, Typography, IconButton } from '@mui/material';
import '../Css/AssessmentCredits.css';

export default function SubscriptionItem({ credit, DualValueProgressBar, TimeZoneHandler, userType }) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12 || 12;

    return `${day}/${month}/${year} • ${hours}:${minutes} ${ampm}`;
  };

  // Check if the credit package is expired
  const isExpired = () => {
    const expirationDate = new Date(credit.expiration_date);
    const currentDate = new Date();
    return expirationDate < currentDate;
  };

  const expired = isExpired();

  return (
    <>
      <div key={credit.id} className="d-flex justify-content-between" style={{
        opacity: expired ? 0.5 : 1,
        filter: expired ? 'grayscale(60%)' : 'none',
        transition: 'opacity 0.3s ease, filter 0.3s ease'
      }}>
        <div className='w-100 col-md-8 px-0'>
          <div className="mb-4 row">
            <div className='col-12 col-md-6 px-0'>
              <strong style={{ color: expired ? '#666' : 'inherit' }}>
                <InventoryIcon style={{ color: expired ? "#999" : "#FBC02D" }} /> {credit.package_name}
              </strong>
            </div>
            <div className='col-md-1 px-0'><span className="mx-2" style={{ color: expired ? '#999' : 'inherit' }}>|</span></div>
            <div className='col-12 col-md-5 px-0'>
              <span className="text-muted" style={{ color: expired ? '#999' : 'inherit' }}>
                {credit.payment_Method === "Free Credits"
                  ? credit.payment_Method
                  : credit.amount_Paid}
              </span>
            </div>

          </div>
          <div className="mb-2">
            <strong className="" style={{ color: expired ? '#666' : 'inherit' }}>
              Total Credits : {credit.total_credits}
              {expired && (
                <span 
                  style={{
                    backgroundColor: '#ff4444',
                    color: 'white',
                    padding: '2px 6px',
                    borderRadius: '8px',
                    fontSize: '0.7rem',
                    fontWeight: 'bold',
                    marginLeft: '8px',
                    textTransform: 'uppercase'
                  }}
                >
                  Expired
                </span>
              )}
            </strong>
          </div>
          <div className='balance mb-2'>
            <small className='used' style={{ color: expired ? '#999' : 'inherit' }}>Used : {credit.used_credits}</small>
            <small className='left' style={{ color: expired ? '#999' : 'inherit' }}>Left : {credit.total_credits - credit.used_credits}</small>
          </div>
          {/* <div className="mb-2">
            <DualValueProgressBar
              used={credit.used_credits}
              total={credit.total_credits}
              filledColor="#8e24aa"
            />
          </div> */}
          {userType === "parent" && (
            <small className="" style={{ color: expired ? '#999' : 'inherit' }}>
              Student : {credit.student}
            </small>
          )}
          <br />
          <small className="" style={{ color: expired ? '#999' : 'inherit' }}>
            {expired ? (
              <>
                <span style={{ 
                  color: '#ff4444', 
                  fontWeight: 'bold' 
                }}>
                  Expired on : 
                </span>
                {formatDateTime(credit.expiration_date)}
              </>
            ) : (
              <>Expires in : {formatDateTime(credit.expiration_date)}</>
            )}
          </small>
        </div>
        <div className='d-flex flex-column col-md-4 px-0 d-flex justify-content-between'>
          <div className="d-flex justify-content-end">
            <IconButton onClick={handleOpen} style={{ color: expired ? '#999' : 'inherit' }}>
              <RemoveRedEyeIcon />
            </IconButton>
          </div>
          <div className='row d-flex justify-content-end'>
            <div className='text-success' style={{ color: expired ? '#999' : 'inherit' }}>
              <p>Paid - </p>
            </div>
            <div>
              <p style={{ color: expired ? '#999' : 'inherit' }}>{credit.paid_By?.split(' ')[0]}</p>
            </div>
          </div>
        </div>
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="credit-modal-title"
        aria-describedby="credit-modal-description"
      >
        <Box sx={modalStyle}>
          <Typography id="credit-modal-title" variant="h6" component="h2">
            Transaction Details
          </Typography>
          <Typography id="credit-modal-description" sx={{ mt: 2 }}>
            {credit.transaction &&
              Object.entries(credit.transaction).map(([key, value]) => (
                <span key={key}>
                  <strong>{key}:</strong> {key === "Exp. Date" || key === "Purchase Date"
                    ? TimeZoneHandler.convertTime(value)
                    : value}<br />
                </span>
              ))
            }
          </Typography>
        </Box>
      </Modal>
    </>
  );
}
